export default function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-array/src/descending.js
// module id = ../../../../d3-array/src/descending.js
// module chunks = 4